<template>
  <div class="lead-view-right">
    <div class="lead-edit">
      <div class="lead-edit-menu">
        <div class="lead-edit-menu-list">
          <ul class="edit-menu-list">
            <li v-for="tab in tabs"
                class="edit-menu-list--item"
                :class="{'edit-menu-list-active' : tab.isActive}"
                @click="changeTab(tab.code)"
            >
              <a>{{ tab.name }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="gen-form-container">
        <comment-tab v-if="activeTab === 'comment'" />
        <transactions-tab v-if="activeTab === 'deposits'" />
        <profile-tab v-if="activeTab === 'profile'" />
        <document-tab v-if="activeTab === 'documents'" />
        <sp-trades-tab v-if="activeTab === 'sp_trades'" />
      </div>
    </div>
    <time-line-tab />
  </div>
</template>

<script>
import CommentTab from "../tabs/CommentTab";
import TimeLineTab from "../timeline/TimeLineTab";
import ProfileTab from "../tabs/ProfileTab";
import DocumentTab from "../tabs/DocumentTab";
import TransactionsTab from "../timeline/partials/TransactionsTab";
import SpTradesTab from "../tabs/SpTradesTab";

export default {
  name: "LeadViewRight",
  components: {SpTradesTab, TransactionsTab, DocumentTab, ProfileTab, TimeLineTab, CommentTab},
}
</script>

<style scoped>

</style>
